var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"height":"100%","align":"center"}},[_c('v-card-title',{staticClass:"pl-6 pt-4 font-weight-light"},[_vm._v(" 12mth Total Charges ($) ")]),_c('apexchart',{staticClass:"pl-1 pr-1",attrs:{"type":"bar","options":_vm.chartOptions,"series":_vm.series,"height":"330px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }